export enum TagClassification {
	CLINIC = "CLINIC",
	ADMINISTRATIVE = "ADMINISTRATIVE",
}
